import React, { useContext, useState } from "react";
import { useParams } from "react-router-dom";
import products from "../data/products";
import { CartContext } from "../context/CartContext";
import { FaHeart, FaStar, FaCheckCircle } from "react-icons/fa";
import "./ProductDetails.css";

const ProductDetails = () => {
  const { id } = useParams();

  const {
    addToCart,
    addToWishlist,
    removeFromWishlist,
    wishlist,
  } = useContext(CartContext);

  const product = products.find(
    (item) => item.id.toString() === id
  );

  const [mainImage, setMainImage] = useState(product?.images?.[0]);
  const [qty, setQty] = useState(1);
  const [message, setMessage] = useState(""); // ✅ toast state

  if (!product) return <h2>Product not found</h2>;

  const isInWishlist = wishlist.some(
    (item) => item.id === product.id
  );

  // ✅ ADD TO CART
  const handleAddToCart = () => {
    addToCart({ ...product, qty });
    setMessage("Item added to Cart");

    setTimeout(() => setMessage(""), 2500);
  };

  // ✅ WISHLIST
  const handleWishlist = () => {
    if (isInWishlist) {
      removeFromWishlist(product.id);
      setMessage("Removed from Wishlist");
    } else {
      addToWishlist(product);
      setMessage("Added to Wishlist");
    }

    setTimeout(() => setMessage(""), 2500);
  };

  return (
    <>
      {/* ✅ SAME AMAZON TOAST */}
      {message && (
        <div className="toast">
          <FaCheckCircle className="toast-icon" />
          <span>{message}</span>
          <div className="progress-bar"></div>
        </div>
      )}

      <div className="product-details">

        {/* LEFT */}
        <div className="product-images">
          <div className="thumbnail-list">
            {product.images.map((img, i) => (
              <img
                key={i}
                src={img}
                alt="thumb"
                onClick={() => setMainImage(img)}
              />
            ))}
          </div>

          <div className="main-image">
            <img src={mainImage} alt={product.name} />
          </div>
        </div>

        {/* RIGHT */}
        <div className="product-info">

          {/* ❤️ Wishlist */}
          <div
            className="wishlist-icon"
            onClick={handleWishlist}
          >
            <FaHeart className={isInWishlist ? "active" : ""} />
          </div>

          <h2 className="product-title">{product.name}</h2>

          <div className="rating">
            {[1,2,3,4,5].map((star) => (
              <FaStar key={star} className="star" />
            ))}
            <span>(120 reviews)</span>
          </div>

          <p className="product-price">₹{product.price}</p>

          <p className="product-desc">{product.description}</p>

          {/* Color */}
          <div className="product-option">
            <label>Colors</label>
            <select>
              <option>Red</option>
              <option>Blue</option>
              <option>Black</option>
            </select>
          </div>

          {/* Quantity */}
          <div className="product-option">
            <label>Quantity</label>
            <select
              value={qty}
              onChange={(e) => setQty(Number(e.target.value))}
            >
              {[1,2,3,4,5,6,7,8,9,10].map((num) => (
                <option key={num} value={num}>
                  {num}
                </option>
              ))}
            </select>
          </div>

          {/* ADD TO CART */}
          <button
            className="add-cart-btn"
            onClick={handleAddToCart}
          >
            Add to Cart
          </button>

        </div>
      </div>
    </>
  );
};

export default ProductDetails;